import React from "react";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";

const StyledSwitch = styled(Switch)(({ ownerState }) => {
  const getTranslate = () => {
    if (ownerState.value === 0) return "translateX(0px)";
    if (ownerState.value === null) return "translateX(14px)";
    return "translateX(28px)";
  };

  const getColor = () => {
    if (ownerState.value === 0) return "#4e4949";
    if (ownerState.value === null) return "#9e9e9e";
    return "#1976d2";
  };

  return {
    width: 62,
    height: 34,
    padding: 7,
    "& .MuiSwitch-switchBase": {
      transform: getTranslate(),
      transition: "transform 0.25s ease",
    },
    "& .MuiSwitch-track": {
      backgroundColor: getColor(),
      opacity: 1,
      transition: "background-color 0.25s ease",
      borderRadius: 20,
    },
  };
});

const TriStateSwitch = ({
  value,
  className,
  disabled,
  id,
  name,
  onChange,
  help,
  design,
}) => {

  const nextValue = (current) => {
    if (current === 0) return null;
    if (current === null) return 1;
    return 0;
  };

  const handleClick = () => {
    if (disabled) return;

    const newValue = nextValue(value);

    const fakeEvent = {
      target: {
        value: newValue,
        checked: newValue === 1,
        type: "switch3"
      }
    };

    if (onChange) {
      onChange(fakeEvent, newValue);
    }
  };

  return (
    <Tooltip title={help ?? ""} placement="top">
      <FormGroup className={className ?? undefined}>
        <FormControlLabel
          key={id}
          control={
            <StyledSwitch
              value={value}
              ownerState={{ value }}
              checked={value === 1}
              onClick={handleClick}
              disabled={disabled}
              id={id}
            />
          }
          disabled={disabled}
          label={
            <span
              style={{
                fontSize: "inherit",
                fontWeight: 600,
                lineHeight: "inherit",
              }}
            >
              {design !== "table" ? name : null}
            </span>
          }
        />
      </FormGroup>
    </Tooltip>
  );
};

export default TriStateSwitch;